import { ReactNode, useState } from 'react'
import { FaAngleDown } from 'react-icons/fa'

const faqs = [
    {
        title: "How much time does take to setup The Shopkeeper?",
        content: `
            It really depends on how many products you have and how busy you are. Some merchants complete the process within a couple of hours, but if you have tons of SKUs and not a lot of free time, it could take weeks.

        `
    },
    {
        title: "How much time does take to migrate to The Shopkeeper?",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi molestiae ratione, accusamus deserunt minus tempora incidunt amet exercitationem omnis nemo nisi nesciunt qui quas! Dolores cum inventore ut magni non?"
    },
    {
        title: "Can I Use The Shopkeeper offline?",
        content: "The Shopkeeper is available offline on the first load. But we recommended you connect with internet every now and then in order to sync local data with the cloud."
    },
    {
        title: "What payment method does The Shopkeeper use?",
        content: "The Shopkeeper accepts settlement of bills/fees via a Visa card, Mastercard, MTN mobile money or Vodafone cash."
    },
    {
        title: "Can I export from and import to The Shopkeeper",
        content: "The Shopkeeper allows you to export data ranging from inventory, employees, user logs, expenses, sales and etc. The only data you can import to The Shopkeeper is inventory data and employee data."
    },
    {
        title: "How long does technincal support last?",
        content: "Customer support to our customers is free and everlasting. All you need to do is proof you have a The Shopkeeper account."
    },
]

export default function FAQs() {


    return (
        <section className='p-24 md:px-0 flex flex-col items-center bg-secondary2'>

            <div className='w-2/5 md:w-4/5 mb-7'>
                <h5 className="text-3xl font-bold text-primary text-center">
                    Frequently asked questions
                </h5>
                {/* <p></p> */}
            </div>

            <div className='w-11/12 mt-8 bg-white p-4 duration-300' >

                {
                    faqs.map((faq, index)=>(
                        <Accordion key={index} title={faq.title} index={index+1} content={faq.content} />
                    ))
                }
                
            </div>
            
        </section>
    )
}

const Accordion = ({title, content, index}:{title:string, content:ReactNode, index:string|number})=>{

    const [isChecked, setChecked] = useState(false)
    const handleOnToggle = ()=>{
        setChecked(isChecked === true ? false : true)
    }

    return(
        <div className="w-ful duration-300 rounded-sm">

            <div className="w-full border-b duration-300 border-secondary2 items-center flex justify-between py-5 cursor-pointer">
                <div className='flex mr-2'>
                    <div className="w-2 h-2 bg-primary p-3 rounded-full flex justify-center items-center mr-3">
                        <h4 className="text-xs text-secondary">{index}</h4>
                    </div>
                    <h5 className='text-primary text-xl font-semibold'>
                        {title}
                    </h5>
                </div>
                    <FaAngleDown className={isChecked ? 'text-primary rotate-180 duration-300' : 'text-primary duration-300'} />
                <input type="checkbox" onChange={handleOnToggle} checked={isChecked} className="w-full opacity-0 absolute top-0 left-0 h-full" />
            </div>
            <div className={isChecked === true ? "w-full p-5 duration-300 block bg-secondary2" : "w-full py-3 hidden"}>
                <p className={isChecked === true ? "opacity-100 text-graphite duration-300" : "opacity-0 text-graphite duration-300"}>
                    {content}
                </p>
            </div>
            
        </div>
    )

}